import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  Edition,
} from '../../models/entity';
import {VendorLogo} from 'shared/models/configuration';
import { FeatureToggleService } from 'app/services/feature-toggle.service';

@Component({
  selector: 'app-location-and-edition-table-rapido',
  templateUrl: './location-and-edition-table-rapido.component.html',
  styleUrls: ['./location-and-edition-table-rapido.component.scss'],
})
export class LocationAndEditionTableRapidoComponent implements OnInit {
  public displayedColumns: string[];
  @Input() public editions: Edition[];
  @Input() public tabName: string;
  @Input() public label: string;
  @Input() public itemTitle: string;
  @Input() public fgTitle: string;
  @Input() public isbn: string;
  @Input() public nonIntegratedLogo: { [key: string]: VendorLogo };
  @Output() public tableInited = new EventEmitter();

  public isExpandable: boolean;
  public featureNewEditionsUXDesign: boolean;

  private readonly COMMON_COLUMNS = [
    'date',
    'edition',
    'details',
  ];
  private readonly PHYSICAL_COLUMNS = [
    ...this.COMMON_COLUMNS,
    'publisher',
    'description',
    'isAvailable',
    'actions',
  ];

  constructor(
    private readonly featureToggleService: FeatureToggleService,
  ) { }

  public ngOnInit(): void {
    this.featureNewEditionsUXDesign = this.featureToggleService.getToggles()['VDIS-33338_2025-12-31_new_editions_UX_design'];
    this.isExpandable = this.editions && this.editions.some((item) => item.hasItems);
    this.displayedColumns = [...this.PHYSICAL_COLUMNS];
  }

}
